import { Feather } from '@expo/vector-icons';
import {
  responsiveWidth,
  useResponsiveFontSize,
  useResponsiveHeight,
} from '@/components/Util/reactResponsiveDimensions';
import { useCallback, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import colors from '@/config/colors';
import { PressableNeolexon } from '@/components/PressableNeolexon';

const styles = StyleSheet.create({
  choiceContainer: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    gap: 8,
  },
  circle: {
    backgroundColor: colors.grey,
    borderRadius: 50,
    borderWidth: 2,
    borderColor: colors.darkerGrey,
  },
  feedbackCircle: {
    borderWidth: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  circleCorrect: {
    backgroundColor: colors.primary,
  },
  circleWrong: {
    backgroundColor: colors.red,
  },
  disabledStyle: {
    opacity: 0.5,
  },
  choiceTextSize: {
    marginLeft: responsiveWidth(0.5),
  },
  lastBox: {
    marginBottom: 0,
  },
});

export function Choice({ choice, isDisabled, changeCorrect, isLastBox }) {
  const { isCorrect, choiceText } = choice;
  const [clicked, setClicked] = useState(false);
  const feedBackIconSize = useResponsiveFontSize(2);
  const feedBackStyle = isCorrect ? styles.circleCorrect : styles.circleWrong;
  const feedBackIconName = isCorrect ? 'thumbs-up' : 'thumbs-down';

  const onPress = useCallback(() => {
    setClicked(true);
    if (isCorrect) {
      changeCorrect();
    }
  }, []);

  const responsiveStyles = StyleSheet.create({
    circle: {
      height: useResponsiveFontSize(3.5),
      width: useResponsiveFontSize(3.5),
    },
    choiceTextSize: {
      fontSize: useResponsiveFontSize(1.9),
    },
    box: {
      marginBottom: useResponsiveHeight(3),
    },
  });

  return (
    <PressableNeolexon
      disabled={isDisabled}
      onPress={onPress}
      style={[
        styles.choiceContainer,
        isLastBox ? styles.lastBox : responsiveStyles.box,
      ]}
    >
      {clicked ? (
        <View
          disabled={isDisabled}
          style={[
            styles.circle,
            responsiveStyles.circle,
            styles.feedbackCircle,
            feedBackStyle,
            ((!isCorrect && isDisabled) || (!isCorrect && clicked)) &&
              styles.disabledStyle,
          ]}
        >
          <Feather
            name={feedBackIconName}
            size={feedBackIconSize}
            color={colors.white}
          />
        </View>
      ) : (
        <View
          style={[
            styles.circle,
            responsiveStyles.circle,
            isDisabled && styles.disabledStyle,
          ]}
        />
      )}
      <Text
        style={[
          responsiveStyles.choiceTextSize,
          styles.choiceTextSize,
          ((!isCorrect && isDisabled) || (!isCorrect && clicked)) &&
            styles.disabledStyle,
        ]}
      >
        {choiceText}
      </Text>
    </PressableNeolexon>
  );
}
